import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export type SelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/**
 * Lopettia-flavored native Select — matches Input's surface and focus ring so
 * dropdowns read as part of the same form vocabulary.
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <select
        className={cn(
          'flex h-10 w-full rounded-[6px] border border-[var(--color-lop-border)] bg-[var(--color-lop-bg-card)] px-3 py-2 text-sm text-[var(--color-lop-text-primary)] transition-colors',
          'focus-visible:outline-none focus-visible:border-[var(--color-lop-teal)] focus-visible:bg-[var(--color-lop-bg-card-hi)] focus-visible:shadow-[0_0_0_3px_var(--color-lop-teal-glow)]',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      >
        {children}
      </select>
    );
  },
);
Select.displayName = 'Select';
